<template>
  <v-dialog v-model="value" max-width="500" persistent>
    <v-form @submit.prevent="save()" ref="form" :lazy-validation="true" :disabled="isLoading">
      <v-card v-if="value">
        <v-card-title class="
            d-flex
            justify-space-between
            align-center
            blue
            white--text
            py-2
          ">
          {{ $t('bill.bill_detail') }}
        </v-card-title>
        <v-card-text class="px-3 py-3">
          <span>
            <b>{{ $t('customer.company_name_and_customer_name') }}</b>
          </span>
          <v-text-field
            v-model="formData.customerData.name"
            :rules="[rules.required]"
            :placeholder="$t('customer.company_name_and_customer_name')"
            class="mb-4 input-disable"
            outlined
            dense
            hide-details>
          </v-text-field>
          <p class="mb-3">
            <b>{{ $t('detail') }}</b>
          </p>
          <v-textarea
            v-model="formData.customerData.address"
            :placeholder="$t('address.address_detail')"
            :label="$t('address.address_detail')"
            class="mb-2"
            outlined
            dense
            hide-details
            rows="2"
            no-resize>
          </v-textarea>
          <v-row no-gutters>
            <v-col cols="6">
              <v-text-field
                v-model="formData.customerData.branchName"
                :class="`mb-1${formData.customerData.taxId ? ' mt-11' : ' mt-11'}`"
                :placeholder="$t('address.company_branch')"
                :label="$t('address.company_branch')"
                outlined
                dense
                hide-details>
              </v-text-field>
            </v-col>
            <v-col cols="6" class="ps-1">
              <EditTaxId
                v-model='formData.customerData.taxId'
                :customClassLabel="'d-block mt-2 mb-3'"
                showWarning
                :showLabel='false'
                :getIsVat="customerType == 'company' ? true : false"
                :getIsExport="customerType == 'company' ? true : false"
                showPlaceholder
                :customClassInput="'mb-2'"
                outlined
                dense
                :solo='false'
                :flat='false'
                :counter='false'
                :getRules="rules"
                @onWriteData="onWriteData"
                @input="formData.customerData.taxId = $event" 
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="formData.customerData.tel"
                class="mb-2"
                :placeholder="$t('account.phone_number')"
                :label="$t('account.phone_number')"
                outlined
                dense
                hide-details>
              </v-text-field>
            </v-col>
            <v-col cols="6" class="ps-1">
              <v-text-field
                v-model="formData.customerData.email"
                class="mb-2"
                placeholder="Email"
                label="Email"
                outlined
                dense
                hide-details>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="default"
            outlined
            @click="dismiss()"
            :disabled="isLoading"
          >{{ $t('close') }}
          </v-btn>
          <v-btn
            color="success"
            type="submit"
            elevation="0"
            :disabled="isLoading"
          >
            <v-icon left>mdi-content-save</v-icon> {{ $t('save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

  </v-dialog>
</template>

<script>
import WarningCitizenIdIcon from "./WarningCitizenIdIcon";
import EditTaxId from "@/components/EditTaxId.vue";

export default {
  components: {
    WarningCitizenIdIcon,
    EditTaxId
  },
  props: {
    customerData: Object,
    value: Boolean,
    invoiceId: String,
    receiptId: String,
    customerType: String
  },
  watch: {
    value() {
      this.prepareFormData();
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
        texId: value => value.length == 0 || value.length == 13 || this.$t('validate.please_input_data_correct_thirteen_digit'),
        numbersOnly: value => !value || /^\d+$/.test(value) || this.$t('validate.numbers_only'),
      },
      formData: {
        customerData: {
          name: "",
          address: "",
          branchName: "",
          taxId: "",
          tel: "",
          email: ""
        }
      },
      isLoading: false,
      isError: false,
      isSuccess: false,
    };
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    prepareFormData() {
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (this.customerData) {
        this.formData.customerData = {
          name: this.customerData.name,
          address: this.customerData.address,
          branchName: this.customerData.branchName,
          taxId: this.customerData.taxId,
          tel: this.customerData.tel,
          email: this.customerData.email
        };
      } else {
        this.formData.customerData = {
          name: "",
          address: "",
          branchName: "",
          taxId: "",
          tel: "",
          email: ""
        };
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          if (this.invoiceId) {
            let invoice = await this.$store.dispatch("invoice/updateInvoiceCustomerData", {
              id: this.invoiceId,
              customerData: this.formData.customerData
            });
            this.$emit("onSaveSuccess", invoice);
          } else if (this.receiptId) {
            let receipt = await this.$store.dispatch("receipt/updateReceiptCustomerData", {
              id: this.receiptId,
              customerData: this.formData.customerData
            });
            this.$emit("onSaveSuccess", receipt);
          // } else if (this.receiptId) {
          //   let receipt = await this.$store.dispatch("receipt/updateReceiptCustomerData", {
          //     id: this.receiptId,
          //     customerData: this.formData.customerData
          //   });
          //   this.$emit("onSaveSuccess", receipt);
          } else {
            this.$emit("onError", "Invalid Object ID");
            this.$emit("onSaveCustomerDataMeter", this.formData.customerData);
          }
          this.isLoading = false;
          this.isSuccess = true;
          this.$emit("input", false);
        } catch (error) {
          this.isLoading = false;
          this.$emit("onError", error);
          this.$emit("input", false);
        }
      }
    },
    onWriteData(dataTax) {
      if (this.customerType == 'company' && dataTax) {
        this.formData.customerData.name = dataTax.companyName
        this.formData.customerData.address = dataTax.fullAddress
        // this.$forceUpdate();
        // this.form.addressStreet = dataTax.addressStreet;
        // this.form.addressSubDistrict = dataTax.Thambol;
        // this.form.addressDistrict = dataTax.Amphur;
        // this.form.addressProvince = dataTax.Province;
        // this.form.addressZipcode = dataTax.PostCode;
      }
    }
  },
};
</script>

<style></style>
